import { render } from "./FilterWilayahDistributor.vue?vue&type=template&id=9dd7ccec"
import script from "./FilterWilayahDistributor.vue?vue&type=script&lang=js"
export * from "./FilterWilayahDistributor.vue?vue&type=script&lang=js"
script.render = render

export default script